<template>
  <!-- Modal 1 Pachet-->
  <div class="modal fade" id="aptamil2-pachet" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-4">
              <h3>Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> 2</h3>
              <p class="text-center">Lapte praf, 1.200g, 6-12 luni</p>
              <img class="img-fluid" src="../../../assets/images/pentru-imunitate/2pachet.png">
            </div>
            <div class="col-lg-8">
              <div class="scroll-vertical-band">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" id="home2pachet-tab" data-toggle="tab"
                       href="#home2pachet" role="tab" aria-controls="home" aria-selected="true">Listă
                      ingrediente</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="profile2pachet-tab" data-toggle="tab" href="#profile2pachet"
                       role="tab" aria-controls="profile" aria-selected="false">Ghid de
                      alimentație</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="contact2pachet-tab" data-toggle="tab" href="#contact2pachet"
                       role="tab" aria-controls="contact" aria-selected="false">Declarație
                      nutrițională</a>
                  </li>
                </ul>
              </div>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="home2pachet" role="tabpanel"
                     aria-labelledby="home2pachet-tab">
                  <p> Lactoză (din <strong>lapte</strong> de vacă), uleiuri vegetale (ulei de floarea soarelui bogat în acid oleic, ulei de cocos, ulei de rapiță, ulei de floarea soarelui), <strong>lapte</strong> de vacă degresat, zer demineralizat (din <strong>lapte</strong> de vacă), galactooligozaharide (din <strong>lapte</strong> de vacă), concentrat din zer (din <strong>lapte</strong> de vacă), fructooligozaharide, fosfat tricalcic, ulei de pește, proteină din <strong>lapte</strong> de vacă, clorură de potasiu, citrat de potasiu, magneziu hidrogen fosfat, clorură de colină, ulei din Mortierella alpina, citrat de sodiu, carbonat de calciu, emulsifiant (lecitine (soia)), clorură de sodiu, acid L-ascorbic, L-ascorbat de sodiu, inozitol, L-triptofan, clorură de magneziu, sulfat feros, sulfat de zinc, L-carnitină, DL-alfa tocoferil acetat, antioxidant (ascorbil palmitat), D-pantotenat de calciu, nicotinamidă, sulfat de cupru, hidroclorură de tiamină, retinil palmitat, riboflavină, hidroclorură de piridoxină, acid pteroilmonoglutamic, iodură de potasiu, sulfat de mangan, selenit de sodiu, fitomenadionă, colecalciferol, D-biotină, cianocobalamină. </p>
                </div>
                <div class="tab-pane fade" id="profile2pachet" role="tabpanel"
                     aria-labelledby="profile2pachet-tab">
                  <ol>
                    <li> Spală-te bine pe mâini, sterilizează toate ustensilele utilizate în prepararea laptelui și asigură-te că marginea ambalajului este curată. </li>
                    <li> Fierbe apa potabilă pentru prepararea laptelui timp de 5 minute, apoi lasă la răcit până la cca 40°C.Toarnă în recipientul pregătit (biberon/cănuță) cantitatea de apă fiartă şi răcită, necesară conform dozării pentru o masă. </li>
                    <li> Dozează pudra cu linguriţa din ambalaj. Adaugă pudra conform tabelului de dozare în recipientul pregătit (biberon/cănuță). </li>
                    <li> Închide recipientul şi agită vertical și viguros timp de 10 secunde. Este foarte important să respecți modalitatea și timpul de agitare pentru a dizolva corect pudra. </li>
                    <li> Verifică pe încheietura mâinii tale temperatura laptelui preparat (cca 37°C). </li>
                  </ol>
                </div>
                <div class="tab-pane fade box-shadow" id="contact2pachet" role="tabpanel"
                     aria-labelledby="contact2pachet-tab">
                  <div class="row height-row">
                    <div class="col-md-4 col-4 border-table">
                      <span class="span-black pl-0">Declarație nutrițională</span>
                    </div>
                    <div class="col-md-4 col-4 border-table"><span
                        class="span-black">100 g pudră</span></div>
                    <div class="col-md-4 col-4 border-table border-last"><span class="span-black">13.6 g pudră</span>
                    </div>
                  </div>
                  <valoare></valoare>
                  <grasimi></grasimi>
                  <glucide></glucide>
                  <polioli></polioli>
                  <fibre></fibre>
                  <proteine></proteine>
                  <vitamine></vitamine>
                  <alte></alte>
                  <p style="color: rgb(160, 160, 160); font-size: 12px; padding-left: 15px;"> * pot apărea variații naturale în materia primă</p>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Grasimi from "./Table/grasimi";
import Valoare from "./Table/valoare";
import Glucide from "./Table/glucide";
import Polioli from "./Table/polioli";
import Fibre from "./Table/fibre";
import Proteine from "./Table/proteine";
import Vitamine from "./Table/vitamine";
import Alte from "./Table/alte";

export default {
  components: {
    Grasimi,
    Valoare,
    Glucide,
    Polioli,
    Fibre,
    Proteine,
    Vitamine,
    Alte,
  },
  data() {
    return {}
  },
}
</script>

<style lang="css">
</style>
